import React, {Component, Fragment} from 'react';
import {Route, Switch} from 'react-router-dom';

import APITable from './APITable';
import APIForm from './APIForm';
import PageTitle from "../Layout/AppMain/PageTitle";
import {concatURL} from "./utils";
import AppWrapper from '../Layout/AppWrapper';


export default class APIModel extends Component {
    render() {
        return <Switch>
                                <Route
                                    exact path={`${this.props.match.url}/create/`}
                                    render={
                                        (props) => <AppWrapper>
                                            <div className="app-main__inner">
                                            <PageTitle
                                                heading={this.props.heading}
                                                subheading={this.props.subheading}
                                                icon={this.props.icon}
                                                enablePageTitleCreationButton={false}
                                                headerButtonBackUrl={`${this.props.match.url}/`}
                                                enablePageTitleBackButton={!this.props.backDisabled}
                                            />
                                            <APIForm
                                                apiPath={this.props.apiPath}
                                                modelId={undefined}
                                                method='post'
                                                ArrayFieldTemplate={this.props.ArrayFieldTemplate}
                                                buttonSubmitDisabled={this.props.creationDisabled}
                                                onCustomSubmit={this.props.onCustomSubmit}
                                                customSubmitText={this.props.customSubmitText}
                                                showCustomSubmitFunction={this.props.showCustomSubmitFunction}
                                                defaultData={this.props.defaultData}
                                                deletionDisabled={true}
                                                actionRedirectUrl={
                                                    this.props.actionRedirectUrl !== undefined
                                                        ? this.props.actionRedirectUrl
                                                        : `${this.props.match.url}/`
                                                }
                                                afterSubmitCallback={this.props.afterSubmitCallback}
                                            />
                                            </div>
                                        </AppWrapper>
                                    }
                                />
                                <Route
                                    exact path={`${this.props.match.url}/:id/`}
                                    render={
                                        (props) => <AppWrapper>
                                            <div className="app-main__inner">
                                            <PageTitle
                                                heading={this.props.heading}
                                                subheading={this.props.subheading}
                                                icon={this.props.icon}
                                                headerButtonCreateUrl={concatURL(this.props.match.url, 'create/')}
                                                enablePageTitleCreationButton={!this.props.creationDisabled}
                                                headerButtonBackUrl={`${this.props.match.url}/`}
                                                enablePageTitleBackButton={!this.props.backDisabled}
                                            />
                                            <APIForm
                                                apiPath={this.props.apiPath}
                                                modelId={props.match.params.id}
                                                method='patch'
                                                onCustomSubmit={this.props.onCustomSubmit}
                                                customSubmitText={this.props.customSubmitText}
                                                showCustomSubmitFunction={this.props.showCustomSubmitFunction}
                                                formSchema={this.props.formSchema}
                                                formUISchema={this.props.formUISchema}
                                                ArrayFieldTemplate={this.props.ArrayFieldTemplate}
                                                buttonSubmitDisabled={this.props.updateDisabled}
                                                deletionDisabled={this.props.deletionDisabled}
                                                actionRedirectUrl={`${this.props.match.url}/`}
                                            />
                                            </div>
                                        </AppWrapper>
                                    }
                                />
                                <Route
                                    exact path={`${this.props.match.url}`}
                                    render={
                                        (props) => <AppWrapper>
                                        <div className="app-main__inner">
                                        <APITable
                                            apiPath={this.props.apiPath}
                                            autoReloadInfo={this.props.autoReloadInfo}
                                            registerReloadFunction={this.props.registerReloadFunction}
                                            columnsConfig={this.props.tableColumns}
                                            filtersConfig={this.props.filtersConfig}
                                            tableEmptyMessage={this.props.tableEmptyMessage}
                                            heading={this.props.heading}
                                            subheading={this.props.subheading}
                                            tableOnly={this.props.tableOnly}
                                            hasFilters={this.props.hasFilters}
                                            icon={this.props.icon}
                                            headerButtonCreateUrl={concatURL(this.props.match.url, 'create/')}
                                            creationDisabled={this.props.creationDisabled}
                                            hideFilter={this.props.hideFilter}
                                            apiTableAdditionalSelectOptions={this.props.apiTableAdditionalSelectOptions}
                                        />
                                        </div>
                                        </AppWrapper>
                                    }
                                />
        </Switch>
    }
}
